<template>
  <div class="breadcrumbs">
    <!-- desktop view -->
    <ul class="d-none d-md-block">
      <li v-for="(crumb, index) in crumbs" :key="index">
        <NuxtLink
          v-if="crumb.href && index < crumbs.length - 1"
          :to="crumb.href"
        >
          {{ crumb.values[0].name }}
        </NuxtLink>
        <span v-else>{{ crumb.name }}</span>
      </li>
    </ul>
    <ul class="d-md-none">
      <!-- remove the first item from the list -->
      <li v-for="(crumb, index) in crumbs.slice(1)" :key="index">
        <NuxtLink
          v-if="crumb.href && index === 0"
          :to="crumb.href"
        >
          ...
        </NuxtLink>
        <NuxtLink
          v-else-if="crumb.href && index < crumbs.length - 1"
          :to="crumb.href"
        >
          {{ crumb.values[0].name }}
        </NuxtLink>
        <span v-else>{{ crumb.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    dealName: {
      type: String,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    subcategory: {
      type: Object,
      required: true,
    },
  },
  computed: {
    query() {
      const params = this.$route.fullPath.split('?');
      if (params.length > 1) {
        return `?${params[1].split('#')[0]}`;
      }
      return '';
    },
    crumbs() {
      const crumbArray = [];

      crumbArray.push({
        ...this.group,
        href: `/${this.group.values[0].slug}/`,
      });

      crumbArray.push({
        ...this.category,
        href: `/${this.group.values[0].slug}/${this.category.values[0].slug}/`,
      });

      crumbArray.push({
        ...this.subcategory,
        href: `/${this.group.values[0].slug}/${this.category.values[0].slug}/${this.subcategory.values[0].slug}/`,
      });

      crumbArray.push({
        name: this.dealName,
      });

      return crumbArray;
    },
  },
};
</script>
<style lang="scss" scoped>
.breadcrumbs {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    font-family: Roboto, sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #1b1b1b;

    li + li::before {
      content: '/\00a0';
      margin-left: 5px;
    }

    li {
      display: inline;

      a {
        color: #0e6ef4;
        text-decoration: none;
      }

      a:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
